import "./App.css";
import Header from "./components/Header/Header";
import Navbar from "./components/Navbar/Navbar";
import ProgrammarTeam from "./components/ProgrammarTeam/ProgrammarTeam";

function App() {
  return (
    <div className="App">
      <Navbar />
      <Header />
      <ProgrammarTeam />
    </div>
  );
}

export default App;